// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://apiv2.amcham.com.ar/api/',
  apiUrl: 'https://apiv2.amcham.com.ar/api/',
  connectUrl:'https://www.amcham.com.ar/',
  /*AES Key considerations: https://stackoverflow.com/questions/72570359/cryptojs-javascript-aes-128-ecb-encrypt-decrypt
  * La configuracion debe ser la misma que la del backend  
  */
  aesEncryptionKey: 'qNVI+lPUnUgCAo/tpxwVZIUriJFCHY53s7PjmI7Vw8M=',
  aesIv: 'nOvjWhYtWKGTl8lKw8HNK1fbwSV6f4+fBAK8FCvDVvM=',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
